import { LinkedCard } from '@shared/components/blocks/lib/cards';
import { MBTextBody1 } from '@shared/components/typography';
import { grid } from '@shared/styles';

export function CardSelectItem({ card, testID }: { card: LinkedCard; testID?: string }) {
  return (
    <MBTextBody1 style={{ paddingLeft: grid(1) }} testID={testID}>
      {card.name}
    </MBTextBody1>
  );
}
